module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Investigations" + _vm._s(_vm.type === 'search' ? ' Search' : ''))]), _vm._v(" "), (_vm.type === 'search') ? _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loadData($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.reportTitle),
      expression: "searchDto.reportTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchReportTitle"
    },
    domProps: {
      "value": (_vm.searchDto.reportTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "reportTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.dbNumber),
      expression: "searchDto.dbNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchDbNumber"
    },
    domProps: {
      "value": (_vm.searchDto.dbNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "dbNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.revNo),
      expression: "searchDto.revNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchRevNo"
    },
    domProps: {
      "value": (_vm.searchDto.revNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "revNo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.agencyNumber),
      expression: "searchDto.agencyNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchAgencyNumber"
    },
    domProps: {
      "value": (_vm.searchDto.agencyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "agencyNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.agencyName),
      expression: "searchDto.agencyName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchAgencyName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "agencyName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Agency Name")]), _vm._v(" "), _vm._l((_vm.leadOrganizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.description
      }
    }, [_vm._v(_vm._s(organization.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.fieldOrgNumber),
      expression: "searchDto.fieldOrgNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchFieldOrgNumber"
    },
    domProps: {
      "value": (_vm.searchDto.fieldOrgNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "fieldOrgNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.fieldOrgName),
      expression: "searchDto.fieldOrgName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchFieldOrgName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "fieldOrgName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Field Organization Name")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.description
      }
    }, [_vm._v("\r\n                        " + _vm._s(organization.description) + "\r\n                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.projectType),
      expression: "searchDto.projectType"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchProjectType"
    },
    domProps: {
      "value": (_vm.searchDto.projectType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "projectType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.clientName),
      expression: "searchDto.clientName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchClientName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "clientName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Client Name")]), _vm._v(" "), _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      key: organization.organizationId,
      domProps: {
        "value": organization.description
      }
    }, [_vm._v("\r\n                        " + _vm._s(organization.description) + "\r\n                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.workflowStatusId),
      expression: "searchDto.workflowStatusId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "workflowStatusId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "workflowStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select Workflow Status")]), _vm._v(" "), _vm._l((_vm.workflowList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v(_vm._s(status.description))])
  })], 2)]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "From Date"
    },
    model: {
      value: (_vm.searchDto.startDate),
      callback: function($$v) {
        _vm.$set(_vm.searchDto, "startDate", $$v)
      },
      expression: "searchDto.startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "To Date"
    },
    model: {
      value: (_vm.searchDto.endDate),
      callback: function($$v) {
        _vm.$set(_vm.searchDto, "endDate", $$v)
      },
      expression: "searchDto.endDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.showInactive),
      expression: "searchDto.showInactive"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchDto.showInactive) ? _vm._i(_vm.searchDto.showInactive, null) > -1 : (_vm.searchDto.showInactive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.searchDto.showInactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchDto.showInactive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.searchDto.showInactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.searchDto, "showInactive", $$c)
        }
      }
    }
  })]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "From Date"
    },
    model: {
      value: (_vm.searchDto.shpoReviewStartDate),
      callback: function($$v) {
        _vm.$set(_vm.searchDto, "shpoReviewStartDate", $$v)
      },
      expression: "searchDto.shpoReviewStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "To Date"
    },
    model: {
      value: (_vm.searchDto.shpoReviewEndDate),
      callback: function($$v) {
        _vm.$set(_vm.searchDto, "shpoReviewEndDate", $$v)
      },
      expression: "searchDto.shpoReviewEndDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-check"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.reviewerId),
      expression: "searchDto.reviewerId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchReviewerName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "reviewerId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Reviewer Name")]), _vm._v(" "), _vm._l((_vm.reviewerList), function(reviewer) {
    return _c('option', {
      key: reviewer.userId,
      domProps: {
        "value": reviewer.userId
      }
    }, [_vm._v("\r\n                        " + _vm._s(reviewer.fullName) + "\r\n                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }), _vm._v(" "), _vm._m(14)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isUserRc && _vm.type === 'todo') ? _c('div', {
    staticClass: "col-md-2 form-group"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.showAll),
      expression: "searchDto.showAll"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchDto.showAll) ? _vm._i(_vm.searchDto.showAll, null) > -1 : (_vm.searchDto.showAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.searchDto.showAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchDto.showAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.searchDto.showAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.searchDto, "showAll", $$c)
        }
      }
    }
  })]), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpec.tableData,
      "columns": _vm.gridSpecColumns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Investigation/' + props.row.investigationId,
              hash: '#siteSummary'
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "resources",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.siteCount > 0 || props.row.isolateCount > 0) ? _c('span', [_vm._v("Yes ")]) : _vm._e(), _vm._v(" "), (props.row.siteCount > 0 || props.row.isolateCount > 0) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Investigation/' + props.row.investigationId,
              hash: '#siteSummary'
            },
            "tag": "a"
          }
        }) : _c('span', [_vm._v("No")])], 1)]
      }
    }, {
      key: "daysRemainingUntilDeadline",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('span', {
          style: (_vm.getDaysRemainingStyle(props.row))
        }, [_vm._v("\r\n                                    " + _vm._s(_vm.getDaysRemainingText(props.row)) + "\r\n                                ")])])]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchReportTitle"
    }
  }, [_vm._v("Report Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("DB Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "searchRevNo"
    }
  }, [_vm._v("Rev No (legacy)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchAgencyNumber"
    }
  }, [_vm._v("Agency Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "searchAgencyName"
    }
  }, [_vm._v("Agency Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchFieldOrgNumber"
    }
  }, [_vm._v("Field Org. Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "searchFieldOrgName"
    }
  }, [_vm._v("Field Org. Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchProjectType"
    }
  }, [_vm._v("Project Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchClientName"
    }
  }, [_vm._v("Client Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchProjectType"
    }
  }, [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchFieldOrgName"
    }
  }, [_vm._v("Report Date Range")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "showInactive"
    }
  }, [_vm._v("Show Inactive Projects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchFieldOrgName"
    }
  }, [_vm._v("SHPO Review Date Range")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "searchFieldOrgName"
    }
  }, [_vm._v("SHPO Reviewer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Search")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "showAll"
    }
  }, [_vm._v("Show All ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7aed58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Investigations.vue
// module id = 907
// module chunks = 1